const DEV = 'ws://localhost:4000/socket';
const ROGA_PROD = 'wss://homologacao.docgo.com.br/socket';
const IMA_PROD = 'wss://ima.docgo.com.br/socket';
const IMA_HOMOLOG = 'wss://homolog.ima.docgo.com.br/socket';

const WEBSOCKET_URL = () => {
  switch (location.hostname) {
    case 'localhost':
      return DEV;
    case 'homologacao.docgo.com.br':
      return ROGA_PROD;
    case 'ima.docgo.com.br':
      return IMA_PROD;
    case 'homolog.ima.docgo.com.br':
      return IMA_HOMOLOG;
    default:
      return DEV;
  }
};

export default WEBSOCKET_URL;



// WEBPACK FOOTER //
// ./src/constants/WEBSOCKET_URL.js